"use client";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
} from "@nextui-org/react";

export default function MyTable() {
  const data1 = [
    { value1: "2.5%", value2: "5%", value3: "70%", value4: "30%" },
    { value1: "5%", value2: "10%", value3: "68%", value4: "32%" },
    { value1: "7.5%", value2: "15%", value3: "65%", value4: "35%" },
    { value1: "10%", value2: "20%", value3: "63%", value4: "37%" },
    { value1: "12.5%", value2: "25%", value3: "62%", value4: "38%" },
    { value1: "15%", value2: "30%", value3: "60%", value4: "40%" },
  ];
  return (
    <Table isStriped aria-label="interest table">
      <TableHeader className="">
        <TableColumn className="px-1 sm:px-3 text-xs sm:text-lg py-3 text-secondColor">
          سود سه ماهه
        </TableColumn>
        <TableColumn className="px-1 sm:px-3 text-xs sm:text-lg py-3 text-secondColor">
          سود شش ماهه
        </TableColumn>
        <TableColumn className="px-1 sm:px-3 text-xs sm:text-lg py-3 text-secondColor">
          سهم سرمایه‌گذار
        </TableColumn>
        <TableColumn className="px-1 sm:px-3 text-xs sm:text-lg py-3 text-secondColor">
          سهم مشاور
        </TableColumn>
      </TableHeader>
      <TableBody>
        {data1.map((item, i) => {
          return (
            <TableRow key={i}>
              <TableCell className="text-xs sm:text-medium text-primaryColor">
                {item.value1}
              </TableCell>
              <TableCell className="text-xs sm:text-medium text-primaryColor">
                {item.value2}
              </TableCell>
              <TableCell className="text-xs sm:text-medium">
                {item.value3}
              </TableCell>
              <TableCell className="text-xs sm:text-medium">
                {item.value4}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
